/* eslint-disable max-len */
import 'angular';
import '../../../../../lib/assets/javascripts/devex/urls';
import template from './visualizations_container.template.html?raw';
import './funders_chart.component';
import './places_chart.component';
import './news_topics_chart.component';
import '../../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/pie-chart.directive';
import '../../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/timeline-chart.directive';
/* eslint-enable max-len */

const moduleDependencies = [
  'fundingSearchApp.components.fundersChart',
  'fundingSearchApp.components.placesChart',
  'fundingSearchApp.components.newsTopicsChart',
  'directives.visualizations.pieChart',
  'directives.visualizations.timelineChart',
];

const visualizationsContainerController = function($http, $timeout) {
  const that = this;
  let loadingTimeout;
  that.loading = false;

  /**
   * In order to perform aggregations query, compose the URL using SearchJs params. If no type
   * is currently active (meaning default for type filter applies), extend
   * `params.filter.type` with all possible values of `type` filter. If no type filter
   * provided to endpoint, BE will return empty results.
   *
   * @returns {undefined}
   */
  const getVisualizationAggregations = () => {
    const params = that.searchJs.getParams({
      'includeFilter': true
    });

    params.aggregations = [
      'donors',
      'number_by_month',
      'regions_inferred',
      'countries',
      'regions',
      'news_topics',
      'awardees'
    ];

    // If no filter object or if filter object does not contain a type filter, force type
    // filter values to all possible values
    if (!params.filter || !params.filter.type) {
      params.filter = params.filter || {};
      params.filter.type = ['tender', 'grant', 'open_opportunity', 'pipeline',
        'funding_info', 'contract', 'shortlist'];
    }

    $timeout.cancel(loadingTimeout);
    that.loading = true;

    $http({
      method: 'get',
      url: devex.urls.concatParamsToUrl('/api/funding_projects/aggregations', params)
    }).then(response => {
      that.aggregations = response.data;

      that.locationChartData = that.aggregations[that.activeLocationChartTab];

      loadingTimeout = $timeout(function () {
        that.loading = false;
      }, 300);
    });
  };

  /**
   * On SearchJs paramChange event, only trigger an aggregations search if the
   * `showVisualizations` boolean is ON, that is to say, only if user is looking at
   * visualizations at the moment. Else, do not run search.
   *
   * @returns {undefined}
   */
  const reactUponSearchJsChange = () => {
    if (!that.showVisualizations) {
      return;
    }
    getVisualizationAggregations(); /* eslint-disable-line no-use-before-define */
  };

  that.$onChanges = reactUponSearchJsChange;

  /**
   * On change of SearchJs, run a new aggregation search.
   *
   * @returns {undefined}
   */
  that.$onInit = () => {
    that.searchJs.on('paramChange', reactUponSearchJsChange);
  };
};

const controller = ['$http', '$timeout', visualizationsContainerController];

angular
  .module('fundingSearchApp.components.visualizationsContainer', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('visualizationsContainer', {
    templateUrl: template,
    bindings: {
      searchJs: '<',
      showVisualizations: '<',
      emptyResultsText: '<'
    },
    controllerAs: 'vm',
    controller
  });
